import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { ResourceHub, collectionPageJsonLd } from "@/components/site/ResourceHub";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { loadPublicResourcesForHub } from "@/lib/query-registry";
import { SITE_URL } from "@/lib/i18n";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/resources/technical-seo";
const ALT = "/es/recursos/seo-tecnico";
const DESC = "Shopify technical SEO guides covering crawling, indexation, canonicals, structured data, information architecture, rendering and migration risk.";

export const Route = createFileRoute("/resources/technical-seo")({
  loader: async ({ context }) => {
    await setEdgeHtmlCache();
    return loadPublicResourcesForHub(context.queryClient);
  },
  head: ({ loaderData }) => {
    const resources = (loaderData as any)?.resources ?? [];
    const urls = resources
      .filter((resource: any) => resource.cluster === "technical-seo" || /technical seo|seo|crawl|index|canonical|schema|hreflang|rendering/i.test([resource.slug, resource.title_en, ...(resource.tags_en ?? [])].join(" ")))
      .map((resource: any) => `${SITE_URL}/resources/${resource.slug}`);
    return buildHead({
      locale: "en", title: "Shopify Technical SEO Resources & Guides · Shugert", description: DESC,
      path: PATH, altPath: ALT,
      jsonLd: [
        breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Resources", path: "/resources" }, { name: "Technical SEO", path: PATH }]),
        collectionPageJsonLd("Shopify Technical SEO Resources", `${SITE_URL}${PATH}`, DESC, urls),
      ],
    });
  },
  component: () => (
    <SiteShell>
      <ResourceHub locale="en" cluster="technical-seo" copy={{
        eyebrow: "Technical SEO resources",
        title: "Shopify technical SEO resources for systems that need to be understood correctly.",
        intro: "Guides for crawling, indexation, canonicals, schema, rendering, architecture and migration continuity, separate from conversion optimization.",
        serviceLabel: "See Shopify Technical SEO", serviceHref: "/shopify-technical-seo",
        articlesTitle: "Technical SEO guides", articlesEmpty: "More technical SEO guides are coming soon.",
        read: "Read", min: "min", by: "By", updated: "Updated", backLabel: "Resources", backHref: "/resources",
      }} />
    </SiteShell>
  ),
});
